import React from "react";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="wrap">
          <nav>
            <ul className="nav-ul-footer">
              <li>
                <NavLink
                  to="/"
                  end
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  Cabanyal
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/activities"
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  Activities
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="copyright-div">
        <p>
          &copy; 2023 by{" "}
          <a href="https://www.linkedin.com/in/tom-erik-william-ertvaag-b155b31a2/">
            Tom Ertvaag
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
